<script>
	import { createEventDispatcher } from "svelte";

	export let caption = "";

	const dispatch = createEventDispatcher();
</script>

<div class="caption-container">
	<!-- Previous Arrow -->
	<img
		src="/assets/icon-chevron-left-thin-white.svg"
		alt="left-arrow"
		class="arrow prev"
		on:click={() => dispatch("prevClick")}
		on:keydown={() => {}}
	/>
	<!-- <a class="arrow prev" on:click={() => dispatch("prevClick")}>&#10094;</a> -->
	<!-- Caption -->
	<div>
		<slot />
		{#if caption.length > 0}
			<p class="caption-text" id="caption">{caption}</p>
		{/if}
	</div>
	<!-- Next Arrow -->
	<img
		src="/assets/icon-chevron-right-thin-white.svg"
		alt="right-arrow"
		class="arrow prev"
		on:click={() => dispatch("nextClick")}
		on:keydown={() => {}}
	/>
	<!-- <a class="arrow next" on:click={() => dispatch("nextClick")}>&#10095;</a> -->
</div>

<style>
	/* Container for image text */
	.caption-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		text-align: center;
		font-size: 1.2rem;
		padding: 2px 16px;
		color: white;
		margin: 10px 0;
	}

	/* Next & previous buttons */
	.prev,
	.next {
		cursor: pointer;
		width: auto;
		color: hsla(125, 86%, 100%, 0.7);
		font-weight: bold;
		font-size: 2rem;
		border-radius: 0 3px 3px 0;
		user-select: none;
		-webkit-user-select: none;
		text-decoration: none;
	}

	/* Position the "next button" to the right */
	.next {
		/*   right: 15vw; */
		border-radius: 3px 0 0 3px;
		text-decoration: none;
	}

	/* On hover, add a black background color with a little bit see-through */
	.prev:hover,
	.next:hover {
		color: hsla(125, 26%, 64%, 0.5);
		text-decoration: none;
	}

	.prev:active,
	.next:active {
		color: hsla(125, 86%, 64%, 1);
		text-decoration: none;
	}

	.caption-text {
		background-color: white;
		color: black;
		text-align: start;
		padding: 20px;
		margin: 10px;
	}
</style>
